var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');

var Modal = createReactClass({

  listenKeyboard: function(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.props.onClose();
    }
  },

  componentDidMount: function() {
    $('body').addClass('is-reveal-open');
    if (this.props.onClose) {
      window.addEventListener('keydown', this.listenKeyboard, true);
    }
  },

  componentWillUnmount: function() {
    $('body').removeClass('is-reveal-open');
    if (this.props.onClose) {
      window.removeEventListener('keydown', this.listenKeyboard, true);
    }
  },

  onOverlayClick: function() {
    this.props.onClose();
  },

  onDialogClick: function(event) {
    event.stopPropagation();
  },

  render: function(){
    return (
      <div id={this.props.id + '-reveal-wrapper'} className={this.props.className}>
        <div className="modal-overlay" />
        <div className="modal-content" onClick={this.onOverlayClick}>
          <div id={this.props.id + '-reveal'} className="custom-reveal" onClick={this.onDialogClick}>
            <div id={this.props.id + '-reveal-box'}>
              <button className="close-button" onClick={this.props.onClose}>
                <span aria-hidden="true">&times;</span>
              </button>
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
});

Modal.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.node
};

module.exports = Modal;



// WEBPACK FOOTER //
// ./src/common/routes/components/modals/modal.jsx